const skills = [
  {
    category: "Core Languages",
    icons: [
      { className: "devicon-csharp-plain colored", title: "C#" },
      { className: "devicon-dotnetcore-plain colored", title: ".NET Core" },
      { className: "devicon-java-plain-wordmark colored", title: "Java" },
      { className: "devicon-python-plain-wordmark colored", title: "Python" },
    ],
  },
  {
    category: "Data",
    icons: [
      { className: "devicon-postgresql-plain-wordmark colored", title: "PostgreSQL" },
      { className: "devicon-cassandra-plain-wordmark colored", title: "Cassandra" },
    ],
  },
  {
    category: "Infrastructure",
    icons: [
      { className: "devicon-docker-plain-wordmark colored", title: "Docker" },
      { className: "devicon-kubernetes-plain-wordmark colored", title: "Kubernetes" },
    ],
  },
  {
    category: "Cloud",
    icons: [
      { className: "devicon-amazonwebservices-plain-wordmark colored", title: "AWS" },
      { className: "devicon-azure-plain-wordmark colored", title: "Azure" },
    ],
  },
  // {
  //   category: "Frontend",
  //   icons: [
  //     { className: "devicon-react-original-wordmark colored", title: "ReactJS" },
  //   ],
  // },
];

export default skills;
